import { render, staticRenderFns } from "./SectionFilter.vue?vue&type=template&id=1096820a&scoped=true&"
import script from "./SectionFilter.vue?vue&type=script&lang=js&"
export * from "./SectionFilter.vue?vue&type=script&lang=js&"
import style0 from "./SectionFilter.vue?vue&type=style&index=0&id=1096820a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1096820a",
  null
  
)

export default component.exports